import { isValidPhoneNumber } from 'react-phone-number-input';

const dateValidator = (values) => {
    const errors = {}, start_month = +values.start_month, start_year = +values.start_year, end_month = +values.end_month, end_year = +values.end_year;

    //if ( !values.start_month &&  !values.start_year ) {
    // errors.start_year = 'Start date is required.';
    //}

    if (!values.start_month) {
        errors.start_month = 'Start month is required.';
    }

    if (!values.start_year) {
        errors.start_year = 'Start year is required.';
    }

    if (!values.end_month) {
        errors.end_month = 'End month is required.';
    }

    if (!values.end_year) {
        errors.end_year = 'End year is required.';
    }


    if (!(values.i_still_work_here || values.i_still_study_here)) {
        if (!values.end_month || !values.end_year) {
            errors.end_year = 'Date is required.';
        }
        else {
            const startDate = new Date(start_year, start_month - 1);
            const endDate = new Date(end_year, end_month - 1);
            const now = new Date();
            if (endDate < startDate) {
                errors.end_year = 'End date is before start date.'
            } else if (endDate > now) {
                errors.end_year = 'End date is in the future.'
            }
        }
    }
    return errors;
}

export const validateExperience = (values) => {

    const errors = {};

    if (!values.title) {
        errors.title = 'Title is required.'
    }
    if (!values.company) {
        errors.company = 'Company is required.'
    }

    errors.start_month = dateValidator(values).start_month;
    errors.end_month = dateValidator(values).end_month;
    errors.start_year = dateValidator(values).start_year;
    errors.end_year = dateValidator(values).end_year;

    if (errors.title || errors.company || errors.start_year) {
        errors.errors_on_form = "Error: All mandatory fields need to be complete. Please check and save again."
    }
    return errors;
};

export const validateEducation = (values) => {
    const errors = {};

    if (!values.institution) {
        errors.institution = 'Institution is required.'
    }
    if (!values.qualification) {
        errors.qualification = 'Qualification is required.'
    }

    errors.end_month = dateValidator(values).end_month;
    errors.end_year = dateValidator(values).end_year;

    if (errors.institution || errors.qualification) {
        errors.errors_on_form = "Error: All mandatory fields need to be complete. Please check and save again."
    }
    return errors;
};

export const validatePreferences = (values) => {

    const errors = {};

    if (!values.country_id) {
        errors.country_id = 'Country is required.'
    }

    if (!values.preferred_location) {
        errors.preferred_location = 'Preferred location is required.'
    }

    if (!values.preferred_industry) {
        errors.preferred_industry = 'Preferred industry is required.'
    }

    if (values.location_id && !values.location_id.length) {
        errors.location_id = 'Locations you are willing to travel to is required.'
    }

    if (values.industry_id && !values.industry_id.length) {
        errors.industry_id = 'Industry is required.'
    }

    if (values.market_id && !values.market_id.length) {
        errors.market_id = 'Market is required.'
    }

    if (values.expertise_id && !values.expertise_id.length) {
        errors.expertise_id = 'Expertise is required.'
    }

    if (values.sector_id && !values.sector_id.length) {
        errors.sector_id = 'Sector is required.'
    }


    return errors;
}


const validate = values => {

    const errors = {};

    if (!values.title) {
        errors.title = 'Title is required.'
    }

    ///////////////////////////////////////

    if (!values.name) {
        errors.name = 'Name is required.'
    }

    // if (values.name) {
    //     errors.name = 'nameeee but is it right chars???';
    // } check this

    if (!values.password) {
        errors.password = 'Required'
    } else if (values.password.length < 8) {
        errors.password = 'Must be 8 characters or more'
    }

    //////////////////////////////////////

    if (!values.password_confirmation) {
        errors.password_confirmation = 'Required'
    } else if (values.password_confirmation.length < 8) {
        errors.password_confirmation = 'Must be 8 characters or more.'
    }

    //////////////////////////////////////

    if (!values.first_name) {
        errors.first_name = 'First name is required.'
    }

    /////////////////////////////////////

    if (!values.last_name) {
        errors.last_name = 'Last name is required.'
    }

    ////////////////////////////////////

    if (!values.phone_number) {
        errors.phone_number = 'Phone number is required.'
    }

    ////////////////////////////////////

    if (values.password !== values.password_confirmation) {
        errors.password = 'Passwords do not match.';
        errors.password_confirmation = 'Passwords do not match.';
    }

    return errors;
};

export default validate;


// WEBPACK FOOTER //
// src/client/helpers/SyncValidator.js